import { Menu, Button, Modal, message, Skeleton, Space, Dropdown } from "antd";
import { Link, NavLink, useLocation, useNavigate } from "react-router-dom";
import logo from "../../../assets/images/logo.png";
import { ExclamationCircleFilled } from "@ant-design/icons";
import { parse } from "flatted";
import SubMenu from "antd/lib/menu/SubMenu";
import { useEffect, useState } from "react";
import Get from "../../../services/Get";
import Transaction from "../../../pages/Transaction";

function Sidenav({ color }) {
  const { pathname } = useLocation();
  const { confirm } = Modal;
  const page = pathname.replace("/", "");
  const navigate = useNavigate();
  const user = localStorage.getItem("user");

  const [affiliateJoined, setAffiliateJoined] = useState(false);
  const [isFreePlan, setIsFreePlan] = useState(false);
  const [uplineUser, setUplineUser] = useState();
  const [sidenavEnabled, setSidenavEnabled] = useState(false);

  const parsedUser = JSON.parse(user);

  const handleLogOut = () => {
    confirm({
      title: "Logout",
      icon: <ExclamationCircleFilled />,
      content: "Do you really wanna logout?",
      okText: "Yes, Logout",
      okButtonProps: {
        style: {
          backgroundColor: "#a6cc43",
          borderColor: "#a6cc43",
          color: "#FFFFFF",
        }, // Customize button color
      },
      cancelText: "Cancel",
      cancelButtonProps: {
        style: { color: "#a6cc43", borderColor: "#a6cc43" },
      },
      onOk() {
        console.log("OK");
        localStorage.removeItem("user");
        navigate("/sign-in");
      },
      onCancel() {
        console.log("Cancel");
      },
    });
  };

  const getMlmData = async (page = 1, reg_no) => {
    try {
      const res = await Get.MLMNetwork(parsedUser.id || "", page, reg_no || "");
      if (res.error && res.error === "Not registered") {
        setAffiliateJoined(false);
      } else {
        setAffiliateJoined(true);
        if (res.user.plan_type === "free") {
          setIsFreePlan(true);
        }
      }
    } catch {
      console.log("Error fetching data");
    }
  };

  const getUplineUser = async () => {
    try {
      const res = await Get.MLMUserDetails(parsedUser.id);
      console.log(res);

      if (res.error && res.error === "Not registered") {
        return;
      }
      if (res.error) {
        message.error(res.error);
      } else {
        setUplineUser(res.data.upline);
      }
    } catch (error) {
      message.error(error.message);
    }
  };

  useEffect(() => {
    getMlmData();
    getUplineUser();
    if (parsedUser.name) {
      setSidenavEnabled(true);
    } else {
      setSidenavEnabled(false);
    }
  }, []);

  const dashboard = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M3 4C3 3.44772 3.44772 3 4 3H16C16.5523 3 17 3.44772 17 4V6C17 6.55228 16.5523 7 16 7H4C3.44772 7 3 6.55228 3 6V4Z"
        fill={color}
      ></path>
      <path
        d="M3 10C3 9.44771 3.44772 9 4 9H10C10.5523 9 11 9.44771 11 10V16C11 16.5523 10.5523 17 10 17H4C3.44772 17 3 16.5523 3 16V10Z"
        fill={color}
      ></path>
      <path
        d="M14 9C13.4477 9 13 9.44771 13 10V16C13 16.5523 13.4477 17 14 17H16C16.5523 17 17 16.5523 17 16V10C17 9.44771 16.5523 9 16 9H14Z"
        fill={color}
      ></path>
    </svg>,
    // <svg
    //   xmlns="http://www.w3.org/2000/svg"
    //   width="20"
    //   height="20"
    //   viewBox="0 0 20 20"
    // >
    //   <rect x="2" y="2" width="6" height="6" fill={color} />
    //   <rect x="12" y="2" width="6" height="6" fill={color} />
    //   <rect x="2" y="12" width="6" height="6" fill={color} />
    //   <rect x="8" y="8" width="4" height="4" fill={color} />
    //   <rect x="14" y="14" width="4" height="4" fill={color} />
    // </svg>
  ];

  const tables = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M9 2C8.44772 2 8 2.44772 8 3C8 3.55228 8.44772 4 9 4H11C11.5523 4 12 3.55228 12 3C12 2.44772 11.5523 2 11 2H9Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4 5C4 3.89543 4.89543 3 6 3C6 4.65685 7.34315 6 9 6H11C12.6569 6 14 4.65685 14 3C15.1046 3 16 3.89543 16 5V16C16 17.1046 15.1046 18 14 18H6C4.89543 18 4 17.1046 4 16V5ZM7 9C6.44772 9 6 9.44772 6 10C6 10.5523 6.44772 11 7 11H7.01C7.56228 11 8.01 10.5523 8.01 10C8.01 9.44772 7.56228 9 7.01 9H7ZM10 9C9.44772 9 9 9.44772 9 10C9 10.5523 9.44772 11 10 11H13C13.5523 11 14 10.5523 14 10C14 9.44772 13.5523 9 13 9H10ZM7 13C6.44772 13 6 13.4477 6 14C6 14.5523 6.44772 15 7 15H7.01C7.56228 15 8.01 14.5523 8.01 14C8.01 13.4477 7.56228 13 7.01 13H7ZM10 13C9.44772 13 9 13.4477 9 14C9 14.5523 9.44772 15 10 15H13C13.5523 15 14 14.5523 14 14C14 13.4477 13.5523 13 13 13H10Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const billing = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        d="M4 4C2.89543 4 2 4.89543 2 6V7H18V6C18 4.89543 17.1046 4 16 4H4Z"
        fill={color}
      ></path>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 9H2V14C2 15.1046 2.89543 16 4 16H16C17.1046 16 18 15.1046 18 14V9ZM4 13C4 12.4477 4.44772 12 5 12H6C6.55228 12 7 12.4477 7 13C7 13.5523 6.55228 14 6 14H5C4.44772 14 4 13.5523 4 13ZM9 12C8.44772 12 8 12.4477 8 13C8 13.5523 8.44772 14 9 14H10C10.5523 14 11 13.5523 11 13C11 12.4477 10.5523 12 10 12H9Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const rtl = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3 6C3 4.34315 4.34315 3 6 3H16C16.3788 3 16.725 3.214 16.8944 3.55279C17.0638 3.89157 17.0273 4.29698 16.8 4.6L14.25 8L16.8 11.4C17.0273 11.703 17.0638 12.1084 16.8944 12.4472C16.725 12.786 16.3788 13 16 13H6C5.44772 13 5 13.4477 5 14V17C5 17.5523 4.55228 18 4 18C3.44772 18 3 17.5523 3 17V6Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const profile = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 10C18 14.4183 14.4183 18 10 18C5.58172 18 2 14.4183 2 10C2 5.58172 5.58172 2 10 2C14.4183 2 18 5.58172 18 10ZM12 7C12 8.10457 11.1046 9 10 9C8.89543 9 8 8.10457 8 7C8 5.89543 8.89543 5 10 5C11.1046 5 12 5.89543 12 7ZM9.99993 11C7.98239 11 6.24394 12.195 5.45374 13.9157C6.55403 15.192 8.18265 16 9.99998 16C11.8173 16 13.4459 15.1921 14.5462 13.9158C13.756 12.195 12.0175 11 9.99993 11Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const signin = [
    <svg
      width="20"
      height="20"
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      key={0}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6 2C5.44772 2 5 2.44772 5 3V4H4C2.89543 4 2 4.89543 2 6V16C2 17.1046 2.89543 18 4 18H16C17.1046 18 18 17.1046 18 16V6C18 4.89543 17.1046 4 16 4H15V3C15 2.44772 14.5523 2 14 2C13.4477 2 13 2.44772 13 3V4H7V3C7 2.44772 6.55228 2 6 2ZM6 7C5.44772 7 5 7.44772 5 8C5 8.55228 5.44772 9 6 9H14C14.5523 9 15 8.55228 15 8C15 7.44772 14.5523 7 14 7H6Z"
        fill={color}
      ></path>
    </svg>,
  ];

  const signup = [
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="14"
      height="14"
      viewBox="0 0 14 14"
      key={0}
    >
      <path
        d="M0,2A2,2,0,0,1,2,0H8a2,2,0,0,1,2,2V8a2,2,0,0,1-2,2H2A2,2,0,0,1,0,8Z"
        transform="translate(4 4)"
        fill={color}
      />
      <path
        d="M2,0A2,2,0,0,0,0,2V8a2,2,0,0,0,2,2V4A2,2,0,0,1,4,2h6A2,2,0,0,0,8,0Z"
        fill={color}
      />
    </svg>,
  ];

  const items = [
    {
      key: "1",
      label: <Link to={Transaction}>About Us</Link>,
    },
    {
      key: "2",
      label: <Link to={Transaction}>Terms And Conditions</Link>,
    },
  ];

  return (
    <>
      <div className="brand header-logo" onClick={() => navigate("/")}>
        <img src={logo} alt="" />
      </div>
      {/* <Button
        type="primary"
        size="default"
        className="join-campaign-mobile"
        style={{
          backgroundColor: "#a6cc43",
          borderColor: "#a6cc43",
        }}
        onClick={() => navigate("/user/mahakumbh")}
      >
        Join Mahakumbh 3 Campaign
      </Button> */}
      <Space wrap>
        <Button
          type="primary"
          size="default"
          className="join-campaign-mobile form-btn"
        >
          Wallet - ₹
          {parsedUser && parsedUser.name ? parsedUser.balance : "Loading..."}
        </Button>
      </Space>
      <hr />
      {sidenavEnabled ? (
        <Menu theme="light" mode="inline">
          <SubMenu
            key="home"
            style={{ paddingLeft: "8px !important" }}
            title={
              <Link to={"/user/home"} className="home-tab">
                <span>
                  <span
                    className="icon"
                    style={{
                      background: page === "home" ? color : "",
                    }}
                  >
                    {billing}
                  </span>
                  <span className="label">Home</span>
                </span>
              </Link>
            }
          >
            <Menu.Item key="user-profile">
              <NavLink to="/user/profile">Profile</NavLink>
            </Menu.Item>
            <Menu.Item key="security">
              <NavLink to="/user/security">Security</NavLink>
            </Menu.Item>
          </SubMenu>

          {affiliateJoined ? (
            <SubMenu
              key="affiliate"
              style={{ paddingLeft: "8px !important" }}
              title={
                <span>
                  <span
                    className="icon"
                    style={{
                      background: page === "affiliate-program" ? color : "",
                    }}
                  >
                    {billing}
                  </span>
                  <span className="label">Affiliate Program</span>
                </span>
              }
            >
              <Menu.Item key="affiliate-dashboard">
                <NavLink to="/user/affiliate-program">Dashboard</NavLink>
              </Menu.Item>
              <Menu.Item key="affiliate-tree-level">
                <NavLink to="/user/affiliate-tree">View Tree</NavLink>
              </Menu.Item>
              <SubMenu
                key="affiliate-income"
                style={{ paddingLeft: "8px !important" }}
                title={
                  <span>
                    <span className="label">Income</span>
                  </span>
                }
              >
                <Menu.Item key="affiliate-earnings">
                  <NavLink to="/user/affiliate-income/level">
                    Level Income
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="affiliate-referrals">
                  <NavLink to="/user/affiliate-income/leadership">
                    Leadership Income
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="affiliate-royality">
                  <NavLink to="/user/affiliate-income/royality">
                    Royality Income
                  </NavLink>
                </Menu.Item>
                <Menu.Item key="affiliate-royality">
                  <NavLink to="/user/affiliate-income/utility">
                    Utility Income
                  </NavLink>
                </Menu.Item>
              </SubMenu>

              <Menu.Item key="user-withdrawal">
                <NavLink to="/user/withdraw">Withdraw</NavLink>
              </Menu.Item>
              <Menu.Item key="user-history">
                <NavLink to="/user/withdrawal-history">
                  Withdrawal History
                </NavLink>
              </Menu.Item>

              {uplineUser && (
                <Menu.Item key="user-upline">
                  <NavLink to="/user/your-upline">Your Upline</NavLink>
                </Menu.Item>
              )}
              {isFreePlan && (
                <Menu.Item key="affiliate-royality">
                  <NavLink to="/user/switch-to-paid">
                    Switch to Paid Plan
                  </NavLink>
                </Menu.Item>
              )}
            </SubMenu>
          ) : (
            <Menu.Item key="4">
              <NavLink to="/user/affiliate-program">
                <span
                  className="icon"
                  style={{
                    background: page === "affiliate-program" ? color : "",
                  }}
                >
                  {billing}
                </span>
                <span className="label">Affiliate Program</span>
              </NavLink>
            </Menu.Item>
          )}

          {/* <Menu.Item key="2">
          <NavLink to="/user/affiliate-market">
            <span
              className="icon"
              style={{
                background: page === "affiliate-market" ? color : "",
              }}
            >
              {billing}
            </span>
            <span className="label">Affiliate market</span>
          </NavLink>
        </Menu.Item> */}

          <Menu.Item key="4">
            <NavLink to="/user/recharge">
              <span
                className="icon"
                style={{
                  background: page === "recharge" ? color : "",
                }}
              >
                {dashboard}
              </span>
              <span className="label">Recharge</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="2">
            <NavLink to="/user/bill-pay">
              <span
                className="icon"
                style={{
                  background: page === "bill-pay" ? color : "",
                }}
              >
                {billing}
              </span>
              <span className="label">Pay Bill</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="4">
            <NavLink to="/user/get-qr">
              <span
                className="icon"
                style={{
                  background: page === "get-qr" ? color : "",
                }}
              >
                {billing}
              </span>
              <span className="label">Get QR Code</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="4">
            <NavLink to="/user/insurance">
              <span
                className="icon"
                style={{
                  background: page === "insurance" ? color : "",
                }}
              >
                {billing}
              </span>
              <span className="label">Insurance</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="4">
            <NavLink to="/user/puc-check">
              <span
                className="icon"
                style={{
                  background: page === "puc-check" ? color : "",
                }}
              >
                {tables}
              </span>
              <span className="label">PUC Check</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="4">
            <NavLink to="/user/apply-credit-card">
              <span
                className="icon"
                style={{
                  background: page === "apply-credit-card" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">Apply Credit Card</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="4">
            <NavLink to="/user/bus-booking">
              <span
                className="icon"
                style={{
                  background: page === "bus-booking" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">Book Bus Ticket</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="4">
            <NavLink to="/user/check-challan">
              <span
                className="icon"
                style={{
                  background: page === "check-challan" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">Check Challans</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="11">
            <a
              href="https://dreamtest.in/"
              target="_blank"
              rel="noopener noreferrer"
            >
              <span
                className="icon"
                style={{
                  background: page === "dream" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">Dream Test</span>
            </a>
          </Menu.Item>

          <Menu.Item key="4">
            <NavLink to="/user/transactions">
              <span
                className="icon"
                style={{
                  background: page === "transactions" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">Transactions</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="10">
            <NavLink to="/user/list-business">
              <span
                className="icon"
                style={{
                  background: page === "list-business" ? color : "",
                }}
              >
                {profile}
              </span>
              <span className="label">List Your Business</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="10">
            <NavLink to="/user/support">
              <span
                className="icon"
                style={{
                  background: page === "support" ? color : "",
                }}
              >
                {profile}
              </span>
              <span className="label">Support</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="3">
            <NavLink to="/user/parking">
              <span
                className="icon"
                style={{
                  background: page === "parking" ? color : "",
                }}
              >
                {tables}
              </span>
              <span className="label">Parking</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="4">
            <NavLink to="/user/buy-gps">
              <span
                className="icon"
                style={{
                  background: page === "buy-gps" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">Buy GPS</span>
            </NavLink>
          </Menu.Item>

          {/* <Menu.Item className="menu-item-header" key="5">
            Campaigns
          </Menu.Item>

          <Menu.Item key="5">
            <NavLink to="/user/upload-video">
              <span
                className="icon"
                style={{
                  background: page === "upload-video" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">Nasha Mukti</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="6">
            <NavLink to="/user/mahakumbh">
              <span
                className="icon"
                style={{
                  background: page === "mahakumbh" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">Mahakumbh 3</span>
            </NavLink>
          </Menu.Item> */}

          <Menu.Item className="menu-item-header" key="7">
            Account Pages
          </Menu.Item>

          {parsedUser.role_id == 6 && parsedUser.businessType && (
            <Menu.Item key="9">
              <NavLink to="/user/members">
                <span
                  className="icon"
                  style={{
                    background: page === "members" ? color : "",
                  }}
                >
                  {profile}
                </span>
                <span className="label">
                  {parsedUser.businessType?.name} Management
                </span>
              </NavLink>
            </Menu.Item>
          )}

          {parsedUser.member_type !== null && (
            <Menu.Item key="9">
              <NavLink to="/user/get-id-card">
                <span
                  className="icon"
                  style={{
                    background: page === "get-id-card" ? color : "",
                  }}
                >
                  {profile}
                </span>
                <span className="label">Get ID Card</span>
              </NavLink>
            </Menu.Item>
          )}
          <Menu.Item key="4">
            <NavLink to="/about-us">
              <span
                className="icon"
                style={{
                  background: page === "about-us" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">About Us</span>
            </NavLink>
          </Menu.Item>

          <Menu.Item key="4">
            <NavLink to="/terms-and-conditions">
              <span
                className="icon"
                style={{
                  background: page === "terms" ? color : "",
                }}
              >
                {rtl}
              </span>
              <span className="label">Terms & Conditions</span>
            </NavLink>
          </Menu.Item>
          <Menu.Item key="11">
            <div onClick={handleLogOut} style={{ padding: 16 }}>
              <span className="icon">{signin}</span>
              <span className="label">Logout</span>
            </div>
          </Menu.Item>
        </Menu>
      ) : (
        <Skeleton avatar paragraph={{ rows: 20 }} />
      )}
    </>
  );
}

export default Sidenav;
